module.exports = __webpack_public_path__ + "img/zep1.38828561.jpg";